export const UserTypes = {
  DIRECTOR: 'director',
  DOCTOR: 'doctor',
  NURSE: 'nurse',
  PATIENT: 'patient',
  PHARMACIST: 'pharmacist',
  SUPPLIER: 'supplier',
  SUPPORT: 'support',
} as const;

export type UserType = (typeof UserTypes)[keyof typeof UserTypes];

/** Staff roles that can send messages — excludes patient. */
export type StaffSenderRole = Exclude<UserType, 'patient'> | 'unknown';

export const ROLE_LABEL_MAP: Record<StaffSenderRole, string> = {
  [UserTypes.NURSE]: 'Practice Nurse',
  [UserTypes.SUPPORT]: 'Candor Support',
  [UserTypes.DOCTOR]: 'Practitioner',
  [UserTypes.DIRECTOR]: 'Director',
  [UserTypes.PHARMACIST]: 'Pharmacist',
  [UserTypes.SUPPLIER]: 'Supplier',
  unknown: 'Unknown',
};
